// Route lambda
const api = "https://api.epha.io"

// ------------------------------------
// elastic.search({
//   index: "test",
//   body: {
//     query: {
//       query_string: {
//         query: "id:abc"
//       }
//     },
//     size: 1000
//   },
//   _sourceIncludes: "fields"
// })
// ------------------------------------
exports.text = async function ( body ) {

  const token = localStorage.getItem( "token" )


  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/translate/text`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

exports.data = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/translate/data`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

exports.html = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/translate/html`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}